class ContentTextImage extends HTMLElement {
  constructor() {
    super();
    this.animationEnabled = true;
    this.handleResizeCallback = () => this.handleResponsive();
  }

  connectedCallback() {
    this.initializeComponent();
  }

  initializeComponent() {
    // Check if animation is enabled from data attribute
    const animationEnabled = this.dataset.enableAnimation === 'true';
    this.animationEnabled = animationEnabled;

    // If animations are disabled, remove the animation classes
    if (!this.animationEnabled) {
      this.disableAnimations();
    } else {
      this.enableAnimations();
    }

    // Handle responsive behavior
    this.handleResponsive();
    window.addEventListener('resize', this.handleResizeCallback);
  }

  enableAnimations() {
    // Animations are handled via CSS
    const animatedElements = this.querySelectorAll(
      '.content-text-image__logo, .content-text-image__heading-wrapper, .content-text-image__description-wrapper, .content-text-image__button-wrapper'
    );

    animatedElements.forEach((el) => {
      el.style.opacity = '';
      el.style.animation = '';
    });
  }

  disableAnimations() {
    // Immediately show all elements without animation
    const animatedElements = this.querySelectorAll(
      '.content-text-image__logo, .content-text-image__heading-wrapper, .content-text-image__description-wrapper, .content-text-image__button-wrapper'
    );

    animatedElements.forEach((el) => {
      el.style.opacity = '1';
      el.style.animation = 'none';
    });
  }

  handleResponsive() {
    const content = this.querySelector('.content-text-image__content');
    if (!content) return;

    // This could be used for additional responsive adjustments
    const isMobile = window.innerWidth < 768;
    // Handle mobile-specific adjustments here if needed
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResizeCallback);
  }
}

customElements.define('content-text-image', ContentTextImage);
